<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("customermanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item>
        <router-link :to="`${routerName.usermanagement}`">
          {{ t("userlist") }}
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("vehiclelist")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <a-table
      style="margin-top: 10px"
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 2000 }"
    >
      <template v-slot:bodyCell="{ text, column }">
        <template v-if="column.title === t('customername')">
          {{ text[0] }}</template
        >
        <template v-if="column.title === t('onlineornot')">
          {{ text === "1" ? t("online") : t("offline") }}</template
        >
        <template v-if="column.title === t('vehiclestatus')">
          {{ getVehicleStatus(text, t) }}</template
        >
      </template>
    </a-table>
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { ref, onMounted, computed } from "vue";
import { message } from "ant-design-vue";
import { useRoute } from "vue-router";
import { getVehicleStatus } from "@/constant/DataType";
import { useStore } from "vuex";
import routerName from "@/router/routerName";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n();

    const dataSource = ref();
    const route = useRoute();
    const id = route.query.id;
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const getListData = () => {
      const params = {
        user_id: id,
      };
      Api.getUserCars(params).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    onMounted(() => {
      getListData();
    });
    return {
      dataSource,
      columns: [
        {
          title: t("vehiclevin"),
          dataIndex: "vin",
          key: "vin",
          align: "left",
        },
        {
          title: t("vehiclename"),
          dataIndex: "vehicle_name",
          key: "vehicle_name",
          align: "left",
        },
        {
          title: t("customername"),
          dataIndex: "customer_name",
          key: "customer_name",
          align: "left",
        },
        {
          title: t("vehiclemodel"),
          dataIndex: "vehicle_model",
          key: "vehicle_model",
          align: "left",
        },
        {
          title: t("onlineornot"),
          dataIndex: "is_login",
          key: "is_login",
          align: "left",
        },
        {
          title: t("vehiclestatus"),
          dataIndex: "vehicle_status_service",
          key: "vehicle_status_service",
          align: "left",
        },
      ],
      getVehicleStatus,
      maxHeight,
      routerName,
      t,
    };
  },
};
</script>
<style scoped></style>
